import * as types from './mutation-types'

export const setActiveTab = ({commit}, tab) => {
    commit(types.SET_TAB, tab)
}

export const setGender = ({commit}, gender) => {
    commit(types.SET_GENDER, gender)
}

export const setAge = ({commit}, age) => {
    commit(types.SET_AGE, age)
}

export const setNoofPhotos = ({commit}, n) => {
    commit(types.SET_NOOF_PHOTOS, n)
}
